import { match } from 'ts-pattern'
import { RegionViewModel } from 'functions/app/geography/view/region'
import { regionsTabs } from '../constants'
import type { RegionsMunicipalitiesFeatures } from '@schema/featureToggle'
import { isFeatureAvailable, isFeatureEnabled } from '@app/util/featureToggle'

export type RegionalLayoutTabAvailabilityContext = {
  expertsCount: number
  plotsCount: number
}

export const isRegionalLayoutTabAvailable = (
  region: RegionViewModel,
  tab: RegionsMunicipalitiesFeatures,
  context: RegionalLayoutTabAvailabilityContext,
): boolean => {
  return match(tab)
    .with(regionsTabs.overview, () => true)
    .with(regionsTabs.discussion, (matchedTab) =>
      isFeatureEnabled(region.featureToggles, matchedTab),
    )
    .with(regionsTabs.initiatives, (matchedTab) =>
      isFeatureEnabled(region.featureToggles, matchedTab),
    )
    .with(regionsTabs.municipalities, (matchedTab) =>
      isFeatureEnabled(region.featureToggles, matchedTab),
    )
    .with(regionsTabs.current, (matchedTab) =>
      isFeatureAvailable(region.featureToggles, matchedTab, [
        region.stories,
        region.news,
        region.blogs,
      ]),
    )
    .with(
      regionsTabs.experts,
      (matchedTab) =>
        isFeatureEnabled(region.featureToggles, matchedTab) &&
        context.expertsCount > 0,
    )
    .with(
      regionsTabs.locations,
      (matchedTab) =>
        isFeatureEnabled(region.featureToggles, matchedTab) &&
        context.plotsCount > 0,
    )
    .with(regionsTabs.knowledgeHub, (matchedTab) =>
      isFeatureAvailable(region.featureToggles, matchedTab, [
        region.knowledgeHubModules,
      ]),
    )
    .otherwise(() => false)
}
